import React from "react";
import { Image } from "@bluecrew/web-react-core";
import { TooltipMessage } from "../TooltipMessage";

export const DirectInviteTooltip = () => (
  <TooltipMessage message="Includes direct invites">
    <Image src={"/public/images/icons/direct-invite.svg"} alt="has direct invite" />
  </TooltipMessage>
);
